<script setup lang="ts">
import type { INotification } from '~/interfaces/notifications/notifications';

defineProps<{ notification: INotification }>();

const auth = useAuthStore();
const { getPlaceholder } = useBranding();
</script>

<template>
  <div
    class="flex flex-col cursor-pointer"
    @click="auth.setAccountModalPage('gifts-offers')"
  >
    <div class="flex items-center gap-2 p-2">
      <LazyDesignSystemLazyImage
        :src="getPlaceholder('contentCardPlaceholder')"
        alt="notification icon"
        class="h-10 w-10 !min-h-10 !min-w-10 rounded-md object-contain text-transparent"
      />
      <span class="font-semibold text-xs">
        {{ notification?.messageHeader }}
      </span>
    </div>
    <div class="relative flex flex-col rounded-b-xl">
      <div
        class="animate-fade p-2 w-full flex gap-2 rounded-b-lg bg-gradient-to-b from-light-100 to-light-800 grow glow h-full min-h-[8.5rem]"
      >
        <div class="w-2/5">
          <LazyDesignSystemLazyImage
            :src="notification?.imageURL || notification?.imageUrl"
            :placeholder="getPlaceholder('categoryCardPlaceholder')"
            class="h-full w-full rounded-xl aspect-square object-cover"
          />
        </div>
        <div class="w-3/5 text-base-priority flex flex-col justify-between">
          <div>
            <LazyAccountGiftsOffersLabel status="allocated" />
            <div class="flex flex-col gap-1 my-1">
              <p class="text-base text-dark-700 font-bold truncate">
                {{ notification?.messageHeader }}
              </p>
              <p
                class="text-xs text-dark-700 line-clamp-2 min-h-8"
                v-html="notification.messageBody"
              />
            </div>
          </div>
          <DesignSystemButton
            type="transparent"
            padding="sm"
            class="bg-dark-400 !text-light-50 w-full justify-center"
          >
            {{ $t('activate') }}
          </DesignSystemButton>
        </div>
      </div>
    </div>
  </div>
</template>
